/**
 * Created by Jerker Nord on 2021-10-18.
 */

export class TrueGritBottomReelBox extends PIXI.Sprite{

    private _isUsed:boolean;

    constructor(texture?: PIXI.Texture) {
        super(texture);
    }

    get isUsed():boolean {
        return this._isUsed;
    }

    set isUsed(value:boolean) {
        this._isUsed = value;
    }
}